import 'react-international-phone/style.css';
import './InternationalPhoneInput/styles/InternationalPhoneInput.scss';
import {useCallback, useState} from 'react';

import {DEFAULT_LABEL} from './constants';
import {InternationalPhoneInput} from './InternationalPhoneInput';

interface PhoneInputTextFieldProps {
  defaultCountry?: string;
  value: string;
  onChange: (phone: string) => void;
  countries?: string[];
  isDisabled?: boolean;
  label?: string;
  placeholder?: string;
  id?: string;
  autocomplete?: string;
  customError?: string;
  showCountryCode?: boolean;
}

export function PhoneInputTextField({
  defaultCountry = 'us',
  value,
  onChange,
  countries,
  isDisabled = false,
  label = DEFAULT_LABEL,
  placeholder = DEFAULT_LABEL,
  id,
  autocomplete = 'phone-number',
  customError,
  showCountryCode = false,
}: PhoneInputTextFieldProps) {
  const [phone, setPhone] = useState(value ?? '');
  const handleOnChange = useCallback(
    (isValid: boolean, phone: string) => {
      setPhone(phone);
      if (!isValid) onChange('');
      else onChange(phone);
    },
    [onChange],
  );

  return (
    <InternationalPhoneInput
      setPhoneNumber={phone}
      defaultCountry={defaultCountry}
      countries={countries}
      isDisabled={isDisabled}
      label={label}
      placeholder={placeholder}
      id={id}
      autocomplete={autocomplete}
      onChange={handleOnChange}
      customError={customError}
      showCountryCode={showCountryCode}
    />
  );
}
